export default __webpack_public_path__ + "static/media/about_four.b62bf06b.png";